import cleanRecipient from './clean-recipient'

export default function cleanRecipientList(recipients: Office.EmailAddressDetails[]): Office.EmailAddressDetails[] {
  const filteredRecipients: Office.EmailAddressDetails[] = []

  recipients.forEach((rawRecipient) => {
    const recipient = cleanRecipient(rawRecipient)
    if (recipient.emailAddress) {
      if (recipient.displayName.indexOf('@') >= 0) {
        recipient.displayName = ''
      }
      filteredRecipients.push(recipient)
    }
  })

  return filteredRecipients
}
